import { CleaveInput } from "@interface48/form-controls";
import InputAdornment from "@material-ui/core/InputAdornment";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";
import { processValue } from "../utils";
import { WidgetProps } from "./models";

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    inputLeftAligned: {
      textAlign: "left",
    },
    inputRightAligned: {
      textAlign: "right",
    },
    adornment: {
      "& p": {
        fontSize: "1rem",
      },
    },
  });

interface NumericWidgetProps extends WidgetProps<string | number>, WithStyles<typeof styles> {
  options: {
    units?: {
      symbol: string;
      position: "start" | "end";
    };
    inputTextAlignment?: "left" | "center" | "right";
  };
}

export const NumericWidgetComponent = (props: NumericWidgetProps) => {
  const { id, schema, options: uiOptions, required, placeholder, value, onChange, classes } = props;

  let startAdornmentProps: { symbol: string; position: "start" } | undefined;
  let endAdornmentProps: { symbol: string; position: "end" } | undefined;

  if (uiOptions?.units != null) {
    if (uiOptions.units.symbol == null || uiOptions.units.position == null) {
      throw Error("symbol and position must be specified for units.");
    }
    if (uiOptions.units.position === "start") {
      startAdornmentProps = { symbol: uiOptions.units.symbol, position: uiOptions.units.position };
    } else if (uiOptions.units.position === "end") {
      endAdornmentProps = { symbol: uiOptions.units.symbol, position: uiOptions.units.position };
    }
  }

  const inputTextAlignment = uiOptions?.inputTextAlignment ?? "left";

  const processNumericValue = (value: string | number | undefined | null) => {
    return processValue(value, schema.type, required) as string | number | null | undefined;
  };

  const rootClassName = classNames(
    classes.root,
    inputTextAlignment === "left" ? classes.inputLeftAligned : classes.inputRightAligned,
  );

  return (
    <CleaveInput
      id={id}
      placeholder={placeholder}
      value={value as string}
      processValue={processNumericValue}
      onChange={onChange}
      startAdornment={
        startAdornmentProps ? (
          <InputAdornment classes={{ root: classes.adornment }} position={startAdornmentProps.position}>
            {startAdornmentProps.symbol}
          </InputAdornment>
        ) : (
          undefined
        )
      }
      endAdornment={
        endAdornmentProps ? (
          <InputAdornment classes={{ root: classes.adornment }} position={endAdornmentProps.position}>
            {endAdornmentProps.symbol}
          </InputAdornment>
        ) : (
          undefined
        )
      }
      className={rootClassName}
      cleaveOptions={{ numeral: true, numeralPositiveOnly: true }}
    />
  );
};

export const NumericWidget = withStyles(styles)(NumericWidgetComponent);
